export default class Offer {
  constructor(item, lang) {
    this._setId(item);
    this._setTitle(item.suggestType, lang);
    this._setDescription(item, lang);
    this._setIcon(item.suggestType);
  }

  _setId({ id }) {
    this.id = id;
  }

  _setTitle(item, lang) {
    let key = "name_" + lang;
    this.title = item[key];
  }

  _setDescription(item, lang) {
    let key = "description_" + lang;
    let value = item[key] || "";
    this.description = value.replace(/&nbsp;/g, " ");
  }

  _setIcon(suggestType) {
    this.svgCode = (suggestType && suggestType.svgCode) || null;
    this.iconUrl = (suggestType && suggestType.photoUrl) || null;
    this.iconColor = (suggestType && suggestType.iconColor) || null;
  }
}
